import { prioritySchema } from './priority';
import { PRIORITY_LABELS } from './priority-labels';

export const PRIORITY_OPTIONS = prioritySchema.options.map((value) => ({
  value,
  label: PRIORITY_LABELS[value],
}));
